<template>
 <div class="diy-goods" :style="'background:'+itemStyle.background">
  <div :class="'goods-list display__'+itemStyle.display+' column__'+itemStyle.column">
    <div :style="'overflow-x:'+itemStyle.display === 'slide' ? true : false">
      <div class="goods-item" v-for="(dataItem,index) in datalist" :key="index">
        <div @click="_onTargetGoods(dataItem.goods_id)">
          <div formType="submit" class="btn-normal" :data-id="dataItem.goods_id">
            <!-- 商品图片 -->
            <div class="goods-image">
              <img src="../../assets/frame-img/logo.png" class="logo">
              <img mode="aspectFill" :src="dataItem.image | thumbnail(375,375)">
            </div>
            <div class="detail">
              <!-- 商品标题 -->
              <p v-if="itemStyle.show.goodsName" class="goods_name" :class="'f-30'+ itemStyle.column > 1 ? 'twolist-hidden' : ''">
                {{ dataItem.goods_name }}
              </p>
              <!-- 商品卖点 -->
              <p v-if="itemStyle.show.sellingPoint && itemStyle.column == 1" class="selling-point f-30">j
                {{ dataItem.selling_point }}
              </p>
              <!-- 商品价格 -->
              <div class="detail-price onelist-hidden">
                <p v-if="itemStyle.show.goodsPrice" class="goods-price f-30 ">￥{{ dataItem.goods_price }}</p>
                <p v-if="itemStyle.show.linePrice && dataItem.line_price > 0" class="line-price col-9 f-24">￥{{ dataItem.line_price }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params","datalist"],
  created(){
  },
  activated() {
  },
  methods:{
    _onTargetGoods(id){
      this.$router.push({
        path:"/pages/goods/index",
        query:{
          id:id
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.logo {
  position: absolute;
  top: 10px !important;
  width: 30px !important;
  height: 15px !important;
  left: 70% !important;
  z-index: 1;
}
/* 商品组 */
.diy-goods{
  overflow: hidden;
}


.diy-goods .goods-list {
  padding: 2px;
  box-sizing: border-box;
}

.diy-goods .goods-list .goods-item {
  box-sizing: border-box;
  padding: 3px;
}

.diy-goods .goods-list.display__slide {
  white-space: nowrap;
  font-size: 0;
}

.diy-goods .goods-list.display__slide .goods-item {
  display: inline-block;
}

.diy-goods .goods-list.display__list .goods-item {
  float: left;
}

.diy-goods .goods-list.column__1 .goods-item {
  width: 100%;
}

.diy-goods .goods-list.column__1 .goods-item .goods-name {
  height: auto !important;
  min-height: 25px;
}

.diy-goods .goods-list.column__2 .goods-item {
  width: 50%;
}

.diy-goods .goods-list.column__3 .goods-item {
  width: 33.33333%;
}

.btn-normal{
  width: 100%;
}

.diy-goods .goods-list .goods-item .goods-image {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  overflow: hidden;
  background: #fff;
  position: relative;
}

.diy-goods .goods-list .goods-item .goods-image:after {
  content: '';
  display: block;
  margin-top: 100%; /* margin 百分比相对父元素宽度计算 */
}

.diy-goods .goods-list .goods-item .goods-image img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  -o-object-fit: cover;
  object-fit: cover;
}

.diy-goods .goods-list .goods-item .detail {
  padding: 4px;
  background: #fff;
}

.diy-goods .goods-list .goods-item .detail .goods_name {
  font-size: 15px;
  line-height: 1.3;
  white-space: normal;
  height:38px;
  display:-webkit-box;
word-break:break-all;
text-overflow:ellipsis;
overflow:hidden;
-webkit-box-orient:vertical;
-webkit-line-clamp:2;


}

.diy-goods .goods-list .goods-item .detail .selling-point {
  font-size: 12px;
  color: @text;
}

.diy-goods .goods-list .goods-item .detail .detail-price .goods-price {
  margin-right: 4px;
  color: @text;
}

.diy-goods .goods-list .goods-item .detail .detail-price .line-price {
  text-decoration: line-through;
}

</style>